import styled from 'styled-components';

export const Container = styled.div`
  color: ${({ theme }) => theme.colors.textQuote()};
  display: inline-block;

  > svg {
    max-width: 16px;
    margin: 0 8px;
    width: 100%;
    cursor: help;

    path {
      fill: currentColor;
    }
  }

  &.ghost > svg > path {
    fill: ${props => props.theme.colors.secondary()};
  }
`;
